(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // Ensure filter counter displays the exact count of rendered cards
  function updateVariantCounter() {
    const cards = document.querySelectorAll('.caelo-grid-item');
    if (!cards) return;
    const count = cards.length;
    
    const counterElements = document.querySelectorAll('.filter-count, .product-count, [data-product-count]');
    counterElements.forEach((el) => {
      el.textContent = `${count} ${count === 1 ? 'item' : 'items'}`;
    });
  }

  document.addEventListener('DOMContentLoaded', updateVariantCounter);

  } catch(e) { console.error(e); }
})();
})();
